import { IDocumentoExport } from '@/shared/model/documento-export.model';
import axios from 'axios';

const baseApiUrl = 'api';

export default class PdfExbecariosService {
  public exportCartaNoAdeudo(becaId: string, password?: string): Promise<IDocumentoExport> {
    return new Promise<IDocumentoExport>((resolve, reject) => {
      const url = `${baseApiUrl}/pdf-becas/${becaId}/carta-no-adeudo`;
      const config = {
        params: {} as any,
      };

      if (password) {
        config.params.password = password;
      }

      axios
        .get(url, config)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public exportCartaReconocimiento(becaId: string, password?: string): Promise<IDocumentoExport> {
    return new Promise<IDocumentoExport>((resolve, reject) => {
      const url = `${baseApiUrl}/pdf-becas/${becaId}/carta-reconocimiento`;
      const config = {
        params: {} as any,
      };

      if (password) {
        config.params.password = password;
      }

      axios
        .get(url, config)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }
}
